import React from 'react';

// local dependencies
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';
import { layoutConfig } from 'config/table-configs/call-log';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsCommunicationHistoryCallLogWidgetSuccess as MemberDetailsCommunicationHistoryCallLogWidgetSuccess } from 'ui/views/widgets/memberDetailsCommunicationHistoryCallLogWidget';
 *
 * // render
 * <MemberDetailsCommunicationHistoryCallLogWidgetSuccess propName='propValue'/>
 */
const memberDetailsCommunicationHistoryCallLogWidgetSuccess = ( props ) => {

    return (
        <div className='ui-member-details-communication-history-call-log-widget'>
            <TableSearchWidget
                layoutConfig = { layoutConfig }
                templateType = 'inline'
                tableResponse = { props.componentData }
                requestPayload={ props.requestPayload }
                onActionClick={ props.onActionClick }
            />
        </div>
    );
};

// set display name
memberDetailsCommunicationHistoryCallLogWidgetSuccess.displayName = 'memberDetailsCommunicationHistoryWidget';

// set default props
memberDetailsCommunicationHistoryCallLogWidgetSuccess.defaultProps = {
    requestPayload: {},
};

// prop types
memberDetailsCommunicationHistoryCallLogWidgetSuccess.propTypes = {};

// ***********************************************

/**
 * @type {object}
 * @desc A React presentation/dumb view component preloader.
 * @example
 * import { memberDetailsCommunicationHistoryCallLogWidgetPreloader as MemberDetailsCommunicationHistoryCallLogWidgetPreloader } from 'ui/views/widgets/memberDetailsCommunicationHistoryCallLogWidget';
 *
 * // render
 * <memberDetailsCommunicationHistoryCallLogWidgetPreloader propName='propValue'/>
 */
const memberDetailsCommunicationHistoryCallLogWidgetPreloader = ( ) => {
    return (
        <div className='ui-member-details-communication-history-call-log-widget-preloader'>
            <TableSearchInlineWidgetPreloader
                className='ui-member-details-communication-history-call-log-widget-preloader__table-preloader'
            />
        </div>
    );
};

// set display name
memberDetailsCommunicationHistoryCallLogWidgetPreloader.displayName = 'memberDetailsCommunicationHistoryCallLogWidgetPreloader';

// set default props
memberDetailsCommunicationHistoryCallLogWidgetPreloader.defaultProps = {};

// prop types
memberDetailsCommunicationHistoryCallLogWidgetPreloader.propTypes = {};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsCommunicationHistoryCallLogWidget as MemberDetailsCommunicationHistoryCallLogWidget } from 'ui/views/widgets/memberDetailsCommunicationHistoryCallLogWidget';
 *
 * // render
 * <memberDetailsCommunicationHistoryCallLogWidget propName='propValue'/>
 */
export const memberDetailsCommunicationHistoryCallLogWidget = withNetworkState( memberDetailsCommunicationHistoryCallLogWidgetPreloader, memberDetailsCommunicationHistoryCallLogWidgetSuccess );

